<template>
    <div class="inOtherDetailBox">
            <div class="wrapper">
                <div class="inOtherDetail">
                    <div class="title">{{isZhong?'隐私政策':'PRIVACY POLICY'}}</div>
                    <div class="mainbody" v-html="privacyInfo.content">
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { getSort,getContent } from '../../../api'
export default {
    data() {
        return {
            privacyInfo:{},
            isZhong:false

        };
    },
    async created(){
       const language = this.$cookies.get('language');
       let isZhong;
       let bannerUrl = '';
       let res2;

        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong; 
        let positionInfo = {};
        if(isZhong){
            positionInfo={
                second:'隐私政策',
                third:''
            }
            res2 = await getContent(241);
        }else{
            positionInfo={
                second:'PRIVACY POLICY',
                third:''
            }
            res2 = await getContent(202);
        }

        //更新bannerIn
        const res = await getSort(25);
        bannerUrl = res.data.pic;
        this.$emit('sendBanner', {bannerUrl,positionInfo});
        this.privacyInfo = res2.data;
    },
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inOtherDetailBox {
   background: #fafdfd;  
   padding: 28px 0 66px 0;
}
.inOtherDetail {
   padding: 66px 50px 78px 50px;
   background: #fff;
  .title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      line-height: 44px;
  }
  .mainbody {
      margin-top: 52px;
      line-height: 30px;
      img,video{
          max-width: 100%;
      }  
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/Other/Privacy/Privacy.vue